var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLastSearches = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M11.002 9.002h2c.553 0 1 .444 1 1 0 .553-.444 1-1 1h-3a.997.997 0 0 1-1-.99V5.993c0-.547.444-.99 1-.99a1 1 0 0 1 1 .99zM2.1 5.782a9 9 0 1 1-.288 5.549l1.932-.517a7 7 0 1 0 .116-4.015l2.264 1.307L1.294 9.4 0 4.57z"
})));
export default SvgLastSearches;